/**
 * Studio 네비게이션 아이템 정의 — BottomNav, StudioHeader 공유
 */

import { Home, Camera, Heart, Settings } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface StudioNavItem {
  to: string
  label: string
  icon: LucideIcon
  end: boolean
}

export const STUDIO_NAV_ITEMS: StudioNavItem[] = [
  { to: '/studio', label: '홈', icon: Home, end: true },
  { to: '/studio/ai', label: 'AI 스튜디오', icon: Camera, end: false },
  { to: '/studio/invitations', label: '청첩장', icon: Heart, end: false },
  { to: '/studio/settings', label: '설정', icon: Settings, end: false },
]
